import {
  UserState,
  USER_DATA,
  UserActionTypes,
  SET_USER_NAME,
  USER_LOGGEDIN,
  USER_LOGGEDOUT,
  SET_USER_PERMISSIONS,
} from "./types"

const token = window.localStorage.getItem("loginKey")
const initialState: UserState = {
  isLoggedIn: false,
  token,
  package: {},
}

export function userReducer(
  state = initialState,
  action: UserActionTypes,
): UserState {
  switch (action.type) {
    case USER_DATA:
      return {
        ...state,
        ...action.payload,
      }
    case SET_USER_NAME:
      return {
        ...state,
        name: action.payload,
      }
    case USER_LOGGEDIN:
      return {
        ...state,
        _id: action.payload,
        isLoggedIn: true,
      }
    case USER_LOGGEDOUT:
      return {
        isLoggedIn: false,
        token: null,
        permissions: [],
        package: {},
      }
    case SET_USER_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      }
    default:
      return state
  }
}
